import Image from "next/image";
import type React from "react";
import type { ChapterVisual } from "@/lib/museum/types";
import styles from "./museum.module.css";

export function ChapterImage({
  visual,
  eager = false,
}: {
  visual: ChapterVisual;
  eager?: boolean;
}): React.JSX.Element {
  const treatment = visual.image.treatment ?? "native";
  const treatmentClass = treatment === "contain"
    ? styles.worldPhotoContain
    : treatment === "contain-mobile"
      ? styles.worldPhotoContainMobile
      : "";
  const hasBackdrop = treatment !== "native";

  return (
    <div
      className={`${styles.worldPhoto} ${treatmentClass}`}
      data-chapter-visual={visual.accession.number}
      data-image-treatment={treatment}
      style={{ "--visual-opacity": visual.opacity } as React.CSSProperties}
    >
      {hasBackdrop ? (
        <Image
          src={visual.image.src}
          alt=""
          fill
          sizes="100vw"
          loading={eager ? "eager" : "lazy"}
          className={`${styles.worldPhotoImage} ${styles.worldPhotoBackdrop}`}
          data-image-layer="backdrop"
          style={{ objectPosition: visual.focalPoint }}
        />
      ) : null}
      <Image
        src={visual.image.src}
        alt={visual.accession.alt}
        fill
        sizes="100vw"
        loading={eager ? "eager" : "lazy"}
        className={`${styles.worldPhotoImage} ${styles.worldPhotoForeground}`}
        data-image-layer="foreground"
        style={{ objectPosition: visual.focalPoint }}
      />
    </div>
  );
}
